import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Toggle from 'react-toggle'
import Loading from './widgets/Loading'
import {
    RATE_UPDATE_PAGE_LOADED,
    RATE_UPDATE,
    RATE_UPDATE_PAGE_UNLOADED
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.settings,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: RATE_UPDATE_PAGE_LOADED, payload }),
    onSubmit: (payload) => {
        dispatch({ type: RATE_UPDATE, payload })
    },
    onUnload: () =>
        dispatch({ type: RATE_UPDATE_PAGE_UNLOADED })
});

class RateUpdate extends React.Component {
    constructor() {
        super();
        this.state = {
            rate: '',
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (symbol, rate) => ev => {
            ev.preventDefault();
            const payload = agent.Rates.updateRate(symbol, rate)
            this.props.onSubmit(payload);
        }
    }
    componentWillMount() {
        const payload = agent.Rates.getRate(this.props.match.params.symbol)
        this.props.onLoad(payload);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.rate) {
            Object.assign(this.state, {
                symbol: nextProps.rate.symbol,
                rate: nextProps.rate.rate,
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        if (!this.props.rate) {
            return (
                <Loading />
            )
        }
        const symbol = this.state.symbol;
        const rate = this.state.rate;

        return (
            <div class='pane'>
                <Link className="crumb" to="/rates">&laquo; back to rates</Link>
                <h1>Update Rate</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(symbol, rate)}>
                    <fieldset className="form">
                        <strong>Symbol</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                value={symbol}
                                readOnly
                                onChange={this.updateState('symbol')} />
                        </fieldset>
                        <strong>Rate</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="5500"
                                value={rate}
                                onChange={this.updateState('rate')} />
                        </fieldset>

                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Update
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RateUpdate);



// WEBPACK FOOTER //
// ./src/components/RateUpdate.js